<template>
  <div>
    <v-dialog v-model="dialog" max-width="900" style="overflow: hidden !important;">
      <v-card>
        <v-card-title> {{processType === "new" ? "Yeni Plasiyer Hedefi Ekle" : "Plasiyer Hedefini Düzenle"}}
        <v-spacer></v-spacer>
          <v-btn @click="closeDialog()" color="danger darken-1" style="color:white">
            KAPAT
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div class="container">
            <div class="row">
              <div class="col-lg-6">
                <v-select :disabled="processType === 'edit' " v-model="salespersonTarget.salesPersonCode"
                          label="Plasiyer"
                          clearable
                          dense
                          filled
                          solo
                          placeholder=" "
                          :items="salesPersonList"
                          :item-text="item => item.name"
                          :item-value="item => item.code"
                          @input="$v.salespersonTarget.salesPersonCode.$touch()" @blur="$v.salespersonTarget.salesPersonCode.$touch()"
                          :error-messages=" validationMessages($v.salespersonTarget.salesPersonCode, 'Plasiyer Seçimi') "
                >

                </v-select>
              </div>
              <div class="col-lg-6">
                <v-text-field
                    solo
                    dense
                    filled
                    v-model="salespersonTarget.targetLimit" placeholder="Hedef Limiti"
                    @input="$v.salespersonTarget.targetLimit.$touch()" @blur="$v.salespersonTarget.targetLimit.$touch()"
                    :error-messages=" validationMessages($v.salespersonTarget.targetLimit, 'Hedef') "
                ></v-text-field>
              </div>
              <div class="col-lg-6">
                <v-menu transition="scale-transition" offset-y :close-on-content-click="false" min-width="auto">
                  <template v-slot:activator="{on,attrs}">
                    <v-text-field
                        @input="$v.salespersonTarget.startDate.$touch()"
                        @blur="$v.salespersonTarget.startDate.$touch()"
                        :error-messages=" validationMessages($v.salespersonTarget.startDate, 'Başlangıç Tarihi') "
                        :value="formattedDate(salespersonTarget.startDate)"
                        label="Tarih Aralık Başlangıç"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        dense
                        filled
                        solo
                        placeholder=" "
                        clearable
                        @click:clear="salespersonTarget.startDate = null"
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                      v-model="salespersonTarget.startDate"
                      locale="tr"
                  ></v-date-picker>
                </v-menu>
              </div>
              <div class="col-lg-6">
                <v-menu transition="scale-transition" offset-y :close-on-content-click="false" min-width="auto">
                  <template v-slot:activator="{on,attrs}">
                    <v-text-field
                        @input="$v.salespersonTarget.finishDate.$touch()"
                        @blur="$v.salespersonTarget.finishDate.$touch()"
                        :error-messages=" validationMessages($v.salespersonTarget.finishDate, 'Bitiş Tarihi') "
                        :value="formattedDate(salespersonTarget.finishDate)"
                        label="Tarih Aralık Bitiş"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        dense
                        filled
                        solo
                        placeholder=" "
                        clearable
                        @click:clear="salespersonTarget.finishDate = null"
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                      v-model="salespersonTarget.finishDate"
                      locale="tr"
                  ></v-date-picker>
                </v-menu>
              </div>
            </div>
          </div>
          <div class="d-flex">
            <v-spacer></v-spacer>
            <v-btn small class="me-1" color="secondary" @click="closeDialog()">İptal Et</v-btn>
            <v-btn small color="success" @click="saveTarget">Hedefi Kaydet</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {mapActions, mapState} from "vuex";
import {formattedDate, formatTest} from "@/momentHelper";
import { required} from "vuelidate/lib/validators";
import {validationMixin} from "vuelidate";
import {validationMessages} from "@/validationMessages";
// import SearchSelect from "@/components/searchSelect.vue";

export default {
  mixins: [validationMixin],
  validations() {
    return {
      salespersonTarget: {
        startDate: {required},
        finishDate: {required},
        salesPersonCode: {required},
        targetLimit: {required},
      }
    }
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    processType: {
      type: String,
      default: "new",
    },
    targetId: {
      type: Number,
      default: null,
    },
    targetProp: {
      type: Object,
      default: () => ({
        id: null,
        salesPersonCode: null,
        targetLimit: null,
        startDate: null,
        endDate: null,
      }),
    },
  },
  name: "NewTargetDialog",
  data() {
    return {
      dialog: false,
      userTextSearch: "",
      salespersonTarget: {
        salesPersonCode: null,
        targetLimit: null,
        startDate: null,
        finishDate: null,
      }
    };
  },
  // components: {SearchSelect},
  computed: {
    ...mapState("auth",["user"]),
    ...mapState("current",["salesPersonList"]),
  },
  mounted() {
    this.fetchSalesPersonList({
      params: {},
      body: {},
    })
  },
  methods: {
    validationMessages,
    formattedDate,
    formatTest,
    ...mapActions("target",["salespersonTargetAdd","salespersonTargetUpdate"]),
    ...mapActions("current",["fetchSalesPersonList","fetchSalespersonSingleTarget"]),
    async _fetchSalespersonSingle() {
      let salesPersonSingleResult = await this.fetchSalespersonSingleTarget({
        params: {
          id: this.targetId
        },
        body: {}
      });
      if (salesPersonSingleResult) {
        this.salespersonTarget.salesPersonCode = salesPersonSingleResult.salesPersonCode;
        this.salespersonTarget.targetLimit = salesPersonSingleResult.targetLimit;
        this.salespersonTarget.startDate = salesPersonSingleResult.startDate;
        this.salespersonTarget.finishDate = salesPersonSingleResult.finishDate;
      } else {
        this.salespersonTarget.salesPersonCode = null;
        this.salespersonTarget.targetLimit = null;
        this.salespersonTarget.startDate = null;
        this.salespersonTarget.finishDate = null;
      }
    },
    async _salesPersonTargetAdd() {
      await this.salespersonTargetAdd({
        params: {
          userId: this.user.UserId
        },
        body: {
          salesPersonCode: this.salespersonTarget.salesPersonCode,
          targetLimit: this.salespersonTarget.targetLimit,
          startDate: this.salespersonTarget.startDate,
          finishDate: this.salespersonTarget.finishDate,
        }
      });
    },
    async _salesPersonTargetUpdate() {
      await this.salespersonTargetUpdate({
        params: {
          userId: this.user.UserId
        },
        body: {
          id: this.targetProp.id,
          targetLimit: this.salespersonTarget.targetLimit,
          startDate: this.salespersonTarget.startDate,
          finishDate: this.salespersonTarget.finishDate,
        },
        urlSegments: [],
      });
    },
    closeDialog() {
      this.dialog = false;
      this.$v.$reset();
    },
    async saveTarget() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.processType === 'new') {
          await this._salesPersonTargetAdd();
          this.$parent._fetchSalespersonTargetList();
          this.dialog = false;
        } else {
          await this._salesPersonTargetUpdate();
        }
        this.salespersonTarget = {
          salesPersonCode: null,
          targetLimit: null,
          startDate: null,
          finishDate: null,
        };
        this.closeDialog();
      }
    },
  },
  watch: {
    dialog: function (newVal) {
      this.$emit("dialogChange",newVal)
    },
    showDialog: function (newVal) {
      this.dialog = newVal
    },
    targetProp: function (newVal) {
      this.salespersonTarget = Object.assign({}, newVal);
    },
    'salespersonTarget.startDate': function(newStartDate,) {
      if (this.salespersonTarget.finishDate && newStartDate > this.salespersonTarget.finishDate) {
        this.salespersonTarget.finishDate = newStartDate;
      }
    },
    'salespersonTarget.finishDate': function(newFinishDate,) {
      if (this.salespersonTarget.startDate && newFinishDate < this.salespersonTarget.startDate) {
        this.salespersonTarget.startDate = newFinishDate;
      }
    }
  },

}
</script>

<style scoped>

</style>